import apiClient from './apiClient';

const updatePointAPI = async ({
	                              memberCarId,
	                              point,
	                              baljuCount,
	                              sujuCount,
	                              baljuAmount,
	                              sujuAmount,
	                              reason,
	                              pointAdjustDay
}: {
	memberCarId: string;
	point: number;
	baljuCount?: number;
	sujuCount?: number;
	baljuAmount?: number;
	sujuAmount?: number;
	reason: string;
	pointAdjustDay?: number;
}) => {
	const path = `/api/admin/common/point/adjust`
	const response = await apiClient.post(path, {
		memberCarId,
		point,
		reason,
		pointAdjustDay,
		baljuCount,
		sujuCount,
		baljuAmount,
		sujuAmount,
	});
	return response.data;
}

const pointAPI = {
	updatePointAPI,
};

export default pointAPI;
